export enum MEDICAL_NOTES_FIELDES {
    AGREEMENT = "INTAKE.NOTES.ADD-NOTE.AGREEMENTS",
    GUARANTEES = "INTAKE.NOTES.ADD-NOTE.GUARANTEES",
    CONTACT_MOMENTS = "INTAKE.NOTES.ADD-NOTE.CONTACT_MOMENTS",
    CONTACT_WITH = "Contact With",
    JUDGEMENT = "INTAKE.NOTES.ADD-NOTE.JUDGEMENT",
    CONVERSATION_NOTE = "INTAKE.NOTES.ADD-NOTE.CONVERSATION_NOTE",
    MEDICAL_INFORMATION = "INTAKE.NOTES.ADD-NOTE.MEDICAL_INFORMATION",
    PLAN = "INTAKE.NOTES.ADD-NOTE.PLAN",
    REPATRIATION_PLAN = "INTAKE.NOTES.ADD-NOTE.REPATRIATION_PLAN",
    CASE_DESCRIPTION = "INTAKE.NOTES.ADD-NOTE.CASE_DESCRIPTION",
    COVERAGE_STATEMENTS = "INTAKE.NOTES.ADD-NOTE.COVERAGE_STATEMENTS",
    REPATRIATION_DECISION = "INTAKE.NOTES.ADD-NOTE.REPATRIATION_DECISION",
    MANAGED_BY = "Managed By",
    MEDICAL_TEAM = "INTAKE.NOTES.ADD-NOTE.MEDICAL_TEAM"
}